import { compose } from 'redux'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import BOTContactInfoEVPage from './BOTContactInfoEVPage'

const mapStateToProps = state => ({
  storePhoneNumber: getCurrentStorePhoneNumber(state)
})

export default compose(
  withType({ type: 'BOTContactInfoEVPage' }),
  connect(mapStateToProps)
)(BOTContactInfoEVPage)
